export default "__VITE_PUBLIC_ASSET__4ff53d27__"